// Angular services
import { SearchService } from '@services/helpers/search.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { AppointmentServiceProvider } from '@services/tasks/appointment.service';
import { ValidationProvider } from '@services/helpers/validation.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { ClientsDataServiceProvider } from '@services/client/clients.data.service';
import { TimeConverterProvider } from '@services/helpers/time-converter';
import { ClientServiceProvider } from '@services/client/client.service';
import { ExtraShootServiceProvider } from '@services/tasks/extra-shoot.service';
import { ImageConverterProvider } from '@services/files/image-converter.service';
import { CalendarEventsDataProvider } from '@services/calendar/calendar-events.data.service';
import { RandomStringGeneratorProvider } from '@services/helpers/random-string-generator';
import { IntegrationsDataProvider } from '@services/integrations/integrations.data.service';
import { TemplatesDataProvider } from '@services/data-services/templates-data-service/templates.data.service';
import { PaymentsServiceProvider } from '@services/payments/payments-service/payments.service';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { WorkflowDataProvider } from '@services/workflow/workflow.data.service';
import { WorkflowProvider } from '@services/workflow/workflow-service/workflow.service';
import { WorkflowDragNDropProvider } from '@services/workflow/workflow-drag-n-drop';
import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { MailsDataProvider } from '@services/email/mails.data.service';
import { UtilsServiceProvider } from '@services/utils/utils-service';
import { NotesDataServiceProvider } from '@services/notes/notes.data.service';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { QuestionnairesDataProvider } from '@services/questionnarie/questionnaires.data.service';
import { ContractsDataProvider } from '@services/contract/contracts.data.service';
import { EmailSettingsDataService } from '@services/settings/email-settings.data.service';
import { AccountDataServiceProvider } from '@services/user/account.data.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { UserServiceWebProvider } from '@web-services/user/user.service';
import { PromoCodeDataProvider } from '@services/subscription/promo-code.data.service';
import { SettingsProvider } from '@services/settings/settings';
import { LeadsDataServiceProvider } from '@services/lead/leads.data.service';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { PaymentsDataServiceProvider } from '@services/payments/payments-data-service/payments.data.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { LanguageDataProvider } from '@services/language/language.data.service';
import { JobTypesDataProvider } from '@services/job/job-types.data.service';
import { InvoiceServiceProvider } from '@services/invoice/invoice-service/invoice.service';
import { ContractsServiceProvider } from '@services/contract/contracts-service/contracts.service';
import { QuestionnairesServiceProvider } from '@services/questionnarie/questionnaires-service/questionnaires.service';
import { ProductPackagesServiceProvider } from '@mob-providers/product-packages-service/product-packages.data.service';
import { FileDownloadDataServiceProvider } from '@services/files/file-download-service/file-download.data.service';
import { PaymentSchedulesDataProvider } from '@services/payments/payments-schedules-data-service/payments-schedules.data.service';
import { JobServiceProvider } from '@services/job/job.service';
import { LeadServiceProvider } from '@services/lead/lead.service';
import { AmbassadorService } from '@web-services/admin/ambassadors/ambassador.service';
import { AdminUsersDataService } from '@web-services/admin/users/admin-users.data.service';
import { AdminReportsDataService } from '@web-services/admin/users/admin-reports.data.service';
import { PaginationService } from '@services/pagination/pagination.service';
import { CalendarServiceProvider } from '@services/calendar/calendar.service';
import { CalendarIntegrationProvider } from '@services/calendar-integration/calendar-integration.service';
import { CompanySettingsServiceProvider } from '@services/settings/company-settings';
import { DashboardDataServiceProvider } from '@services/dashboard/dashboard.data.service';
import { ProductPackagesDataServiceProvider } from '@services/settings/product-packages.data.service';
import { PaymentMethodsDataProvider } from '@web-services/settings/payment-methods/payment-methods.data.service';
import { ProfileUpdateDataServiceProvider } from '@web-services/profile/profile-update.data.service';
import { ShootProofDataProvider } from '@services/integrations/shootProof/shootProof.data.service';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { SettingsOverviewDataProvider } from '@services/settings/settings-overview/settings-overview.data.service';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { AuthTokensService } from '../../modern/auth-tokens.service';
import { HybridHelper } from '../../upgrade/upgradeHelper';
import { CustomizeLabelsService } from '@services/settings/customize.labels.service';
import { PickTimeDataProvider } from '@services/integrations/pickTime/pickTime.data.service';
import { LeadSourcesDataService } from '@services/lead-sources/lead-sources.data.service';
import { DoubleBookingService } from '@services/double-booking/double-booking.service';
import { SystemNotificationsServiceDataProvider } from '@services/system-notifications/system-notifications.service';

import { ReportsOverviewDataProvider } from '@services/admin/reports/reports-overview.data.service';

const moduleName = 'main';

HybridHelper.downgradeProvider(moduleName, 'searchService', SearchService)
	.downgradeProvider(moduleName, 'messageService', MessageService)
	.downgradeProvider(
		moduleName,
		'shootProofDataService',
		ShootProofDataProvider
	)
	.downgradeProvider(
		moduleName,
		'appointmentService',
		AppointmentServiceProvider
	)
	.downgradeProvider(moduleName, 'validationService', ValidationProvider)
	.downgradeProvider(moduleName, 'timeService', TimeServiceProvider)
	.downgradeProvider(moduleName, 'calendarService', CalendarServiceProvider)
	.downgradeProvider(
		moduleName,
		'clientsDataService',
		ClientsDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'calendarIntegrationService',
		CalendarIntegrationProvider
	)
	.downgradeProvider(moduleName, 'timeConverter', TimeConverterProvider)
	.downgradeProvider(moduleName, 'calendarService', CalendarServiceProvider)
	.downgradeProvider(moduleName, 'clientService', ClientServiceProvider)
	.downgradeProvider(moduleName, 'extraShootService', ExtraShootServiceProvider)
	.downgradeProvider(moduleName, 'imageConverter', ImageConverterProvider)
	.downgradeProvider(
		moduleName,
		'calendarEventsDataService',
		CalendarEventsDataProvider
	)
	.downgradeProvider(
		moduleName,
		'stringModifierService',
		StringModifierServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'SettingsOverviewDataService',
		SettingsOverviewDataProvider
	)
	.downgradeProvider(
		moduleName,
		'randomStringGenerator',
		RandomStringGeneratorProvider
	)
	.downgradeProvider(
		moduleName,
		'integrationsDataService',
		IntegrationsDataProvider
	)
	.downgradeProvider(
		moduleName,
		'templateRequestsService',
		TemplatesDataProvider
	)
	.downgradeProvider(moduleName, 'paymentsService', PaymentsServiceProvider)
	.downgradeProvider(moduleName, 'invoicesDataService', InvoicesDataProvider)
	.downgradeProvider(moduleName, 'workflowDataService', WorkflowDataProvider)
	.downgradeProvider(moduleName, 'newWorkflowService', WorkflowProvider)
	.downgradeProvider(
		moduleName,
		'newWorkflowDragNDropService',
		WorkflowDragNDropProvider
	)
	.downgradeProvider(moduleName, 'emailService', EmailServiceProvider)
	.downgradeProvider(moduleName, 'mailsDataService', MailsDataProvider)
	.downgradeProvider(moduleName, 'utilsService', UtilsServiceProvider)
	.downgradeProvider(moduleName, 'notesDataService', NotesDataServiceProvider)
	.downgradeProvider(
		moduleName,
		'fileUploadDataService',
		FileUploadDataProvider
	)
	.downgradeProvider(
		moduleName,
		'newfileUploadService',
		FileUploadServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'questionnairesDataService',
		QuestionnairesDataProvider
	)
	.downgradeProvider(moduleName, 'contractsDataService', ContractsDataProvider)
	.downgradeProvider(
		moduleName,
		'emailSettingsDataService',
		EmailSettingsDataService
	)
	.downgradeProvider(
		moduleName,
		'accountDataService',
		AccountDataServiceProvider
	)
	.downgradeProvider(moduleName, 'accountService', AccountServiceWebProvider)
	.downgradeProvider(moduleName, 'userService', UserServiceWebProvider)
	.downgradeProvider(moduleName, 'promoCodesDataService', PromoCodeDataProvider)
	.downgradeProvider(moduleName, 'settingsService', SettingsProvider)
	.downgradeProvider(moduleName, 'authTokensService', AuthTokensService)
	.downgradeProvider(moduleName, 'leadDataService', LeadsDataServiceProvider)
	.downgradeProvider(moduleName, 'newJobsDataService', JobsDataServiceProvider)
	.downgradeProvider(
		moduleName,
		'paymentsDataService',
		PaymentsDataServiceProvider
	)
	.downgradeProvider(moduleName, 'quotesDataService', QuotesDataProvider)
	.downgradeProvider(moduleName, 'jobTypesDataService', JobTypesDataProvider)
	.downgradeProvider(moduleName, 'languageDataService', LanguageDataProvider)
	.downgradeProvider(moduleName, 'invoiceService', InvoiceServiceProvider)
	.downgradeProvider(moduleName, 'contractService', ContractsServiceProvider)
	.downgradeProvider(
		moduleName,
		'productPackageService',
		ProductPackagesServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'questionnairesService',
		QuestionnairesServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'fileDownloadDataService',
		FileDownloadDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'paymentSchedulesDataService',
		PaymentSchedulesDataProvider
	)
	.downgradeProvider(moduleName, 'jobService', JobServiceProvider)
	.downgradeProvider(moduleName, 'leadService', LeadServiceProvider)
	.downgradeProvider(moduleName, 'ambassadorService', AmbassadorService)
	.downgradeProvider(moduleName, 'adminUsersDataService', AdminUsersDataService)
	.downgradeProvider(
		moduleName,
		'adminReportsDataService',
		AdminReportsDataService
	)
	.downgradeProvider(moduleName, 'paginationService', PaginationService)
	.downgradeProvider(
		moduleName,
		'companySettingsService',
		CompanySettingsServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'customizeLabelsService',
		CustomizeLabelsService
	)
	.downgradeProvider(moduleName, 'paginationService', PaginationService)
	.downgradeProvider(
		moduleName,
		'dashboardDataService',
		DashboardDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'productPackagesDataService',
		ProductPackagesDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'paymentMethodsDataProvider',
		PaymentMethodsDataProvider
	)
	.downgradeProvider(
		moduleName,
		'profileUpdateService',
		ProfileUpdateDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'subscriptionDataService',
		NewSubscriptionServiceDataProvider
	)
	.downgradeProvider(
		moduleName,
		'systemNotificationsService',
		SystemNotificationsServiceDataProvider
	)
	.downgradeProvider(moduleName, 'brandsDataService', BrandsDataServiceProvider)
	.downgradeProvider(moduleName, 'pickTimeDataProvider', PickTimeDataProvider)
	.downgradeProvider(moduleName, 'brandsDataService', BrandsDataServiceProvider)
	.downgradeProvider(
		moduleName,
		'leadSourcesDataService',
		LeadSourcesDataService
	)
	.downgradeProvider(moduleName, 'doubleBookingService', DoubleBookingService)

	.downgradeProvider(
		moduleName,
		'ReportsOverviewDataService',
		ReportsOverviewDataProvider
	);



// WEBPACK FOOTER //
// ./web/js/services/downgradedServices.js